import { Injectable } from '@angular/core';

/**
 * Marks that the push-notification pre-screen has already been shown to the
 * account that is logged in. It lives in the non-secure device storage, so it
 * has to be cleared on logout: the OS permission status it guards is
 * device-wide, and a leftover flag would suppress the screen for every account
 * logging in on the same device afterwards. ART-19735
 */
export const NOTIFICATION_PERMISSION_REQUESTED_KEY = 'notificationPermissionRequested';

@Injectable()
export abstract class StorageService {
  public abstract getItem(key: string): object | string | boolean | null;

  public abstract setItem(key: string, value: object | string | boolean): boolean;

  public abstract removeItem(key: string): boolean;

  public abstract clear(): boolean;
}
